import React, { FC } from 'react';
import { RiDeleteBinLine } from 'react-icons/ri';
import ReactTooltip from 'react-tooltip';
import clsx from 'classnames';
import { Option } from 'common/form/select/select.types';
import { DocumentNameIcon } from '../document-name.icon';
import { DocumentTypeIcon } from '../document-type.icon';

import styles from './document-item.module.scss';

export const DocumentItem: FC<{
  doc: { file: File; id: string; option: Option };
  onDeleteDocument: (id: string) => void;
}> = ({ doc, onDeleteDocument }) => (
  <>
    <ReactTooltip
      backgroundColor="white"
      border
      borderColor="var(--primary)"
      effect="solid"
      id="deleteItemTooltip"
      textColor="var(--primary)"
      type="info">
      Eliminar
    </ReactTooltip>

    <div className={clsx('p-2 items-center rounded-md border gap-2', styles.container)}>
      <div className="flex flex-col">
        <div className={styles.info}>
          <DocumentNameIcon />
          <p className="font-semibold text-ellipsis overflow-hidden whitespace-nowrap">{doc.file.name}</p>
        </div>

        <div className={styles.info}>
          <DocumentTypeIcon />
          <p>{doc.option.label}</p>
        </div>
      </div>

      <RiDeleteBinLine
        className="outline-none cursor-pointer"
        color="#7f7f7f"
        data-for="deleteItemTooltip"
        data-tip
        size="18px"
        onClick={() => onDeleteDocument(doc.id)}
      />
    </div>
  </>
);
